module.exports = __webpack_public_path__ + "static/media/att.3bebc1f8.svg";